// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation EmailInvoiceMutation($input: EmailInvoiceInput!) {
    emailInvoice(input: $input) {
      success
      invoiceStatus
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
      // Write the updated status directly into the Relay store so the UI
      // reflects SENT immediately without requiring a page refresh.
      updater: (store, data) => {
        const invoiceId = options.variables && options.variables.input && options.variables.input.invoiceId;
        const newStatus = data && data.emailInvoice && data.emailInvoice.invoiceStatus;
        if (invoiceId && newStatus) {
          const record = store.get(invoiceId);
          if (record) {
            record.setValue(newStatus, 'status');
          }
        }
      },
    });
  },
};
